module.exports = __webpack_public_path__ + "static/media/image-6.b047fc50.jpeg";